import { Box, CircularProgress, TextField as MuiTextField } from '@mui/material'
import { CSSProperties } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FieldWrapper } from './FieldWrapper'
import { get as _get } from 'lodash'
// import MaskedInput from 'react-text-mask'

interface TextFieldProps {
  name: string
  label?: string
  placeholder?: string
  type?: string
  style?: CSSProperties
  inputProps?: any
  mask?: string
  autoFocus?: boolean
  sx?: any
  multiline?: boolean
  rows?: number
  normalize?: (value: string) => void
  onChange?: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void
  disabled?: boolean
  InputProps?: any
  loading?: boolean
  onBlur?: (
    e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>
  ) => void
}

export const TextFieldC = (props: TextFieldProps) => {
  const {
    label,
    placeholder,
    type,
    style,
    inputProps,
    autoFocus,
    sx,
    multiline,
    rows,
    name,
    onChange,
    onBlur,
    normalize,
    disabled,
    InputProps,
    loading
  } = props

  const { formState } = useFormContext()
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <FieldWrapper error={_get(formState.errors, name)}>
          <MuiTextField
            {...field}
            onChange={(e) => {
              onChange?.(e)
              if (normalize) field.onChange(normalize(e.target.value))
              else field.onChange(e.target.value.toUpperCase())
            }}
            onBlur={(e) => {
              onBlur?.(e)
              field.onBlur()
            }}
            label={label}
            disabled={!!disabled}
            error={!!_get(formState.errors, name)}
            placeholder={placeholder}
            autoComplete="no"
            size="small"
            type={type}
            inputProps={inputProps}
            autoFocus={autoFocus}
            sx={sx}
            multiline={multiline}
            rows={rows}
            onFocus={(e) => e.target.select()}
            onWheel={(e: any) => {
              e?.target?.blur?.()
            }}
            style={{
              width: '100%',
              height: '100%',
              ...style
            }}
            InputProps={{
              ...InputProps,
              autoComplete: 'off',
              endAdornment: (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignSelf: 'center'
                  }}
                >
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}

                  {InputProps?.endAdornment}
                </Box>
              )
            }}
          />
        </FieldWrapper>
      )}
    />
  )
}

TextFieldC.defaultProps = {
  autoFocus: false,
  type: 'text',
  multiline: false,
  rows: 1
}
